"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../IconLink/IconLink");

var SliderPagination =
/** @class */
function (_super) {
  __extends(SliderPagination, _super);

  function SliderPagination(props) {
    return _super.call(this, props) || this;
  }

  SliderPagination.prototype.render = function () {
    var _a = this.props,
        numDots = _a.numDots,
        activeDotIndex = _a.activeDotIndex,
        onPointClick = _a.onPointClick,
        onArrowLeftClick = _a.onArrowLeftClick,
        onArrowRightClick = _a.onArrowRightClick,
        arrowIcon = _a.arrowIcon;
    return React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "slider-pagination"
    }, arrowIcon && React.createElement(IconLink_1.IconLink, {
      iconName: Icon_1.Icon.Names.interaction_arrows_chevronLeft,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: onArrowLeftClick,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "slider-pagination-arrow", CSSPrefix_1.lsgPre + "slider-pagination-arrow-left"]),
      disabled: activeDotIndex === 0
    }, utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.SliderPagination.previousPage), React.createElement("ul", {
      className: CSSPrefix_1.lsgPre + "slider-pagination-pointlist"
    }, Array.from(Array(numDots).keys()).map(function (i) {
      return React.createElement("li", {
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "slider-pagination-point", activeDotIndex === i && CSSPrefix_1.lsgPre + "slider-pagination-point-active"]),
        onClick: function onClick(e) {
          return onPointClick(i, e);
        },
        tabIndex: activeDotIndex === i ? 0 : -1,
        key: i
      }, React.createElement("div", {
        className: CSSPrefix_1.lsgPre + "slider-pagination-point-dot"
      }));
    })), arrowIcon && React.createElement(IconLink_1.IconLink, {
      iconName: Icon_1.Icon.Names.interaction_arrows_chevronRight,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: onArrowRightClick,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "slider-pagination-arrow", CSSPrefix_1.lsgPre + "slider-pagination-arrow-right"]),
      disabled: activeDotIndex === numDots - 1
    }, utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.SliderPagination.nextPage));
  };

  SliderPagination.defaultProps = {
    onArrowRightClick: function onArrowRightClick() {
      /* empty */
    },
    onArrowLeftClick: function onArrowLeftClick() {
      /* empty */
    }
  };
  return SliderPagination;
}(React.Component);

exports.SliderPagination = SliderPagination;